import { render, staticRenderFns } from "./OrdersRoundNav.vue?vue&type=template&id=7085708e&"
import script from "./OrdersRoundNav.vue?vue&type=script&lang=js&"
export * from "./OrdersRoundNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports